import { useLocale } from '../i18n/LocaleContext'
import SEOHead from '../components/SEOHead'

// "Retur/Anulare" — the companion to Delivery, also mandatory for RO
// card-payment merchant verification: the cancellation deadline (30 days before
// the camp) and the refund timeframe must both be stated. Kept in sync with
// Terms §6, which carries the same policy.
export default function Refunds() {
  const { t } = useLocale()

  return (
    <section className="section-padding bg-white">
      <SEOHead title={t.refunds.metaTitle} description={t.refunds.metaDescription} />
      <div className="container-max max-w-3xl">
        <h1 className="mb-2">{t.refunds.title}</h1>
        <p className="text-text-muted text-sm mb-8">{t.refunds.lastUpdated}</p>

        <div className="space-y-8">
          {t.refunds.content.map((section, i) => (
            <div key={i}>
              <h2 className="text-xl font-heading font-medium mb-3">{section.heading}</h2>
              <div className="text-text-secondary leading-relaxed whitespace-pre-line">
                {section.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
